<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row justify-between items-center mb-3">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">
        Manage Anyo Packs subscription
      </h1>
    </div>
  </div>
</div>
<div class="flex items-center justify-end mt-3">
  <div nz-col class="p-1">
      <nz-range-picker
        nzSize="large"
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="dateRange"
        (ngModelChange)="dateChange($event)"
      ></nz-range-picker>
    </div>
  <div class="w-[40%]">
    <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
      <input
        type="text"
        nz-input
        [(ngModel)]="globalSearchInput"
        placeholder="Search by subscription id, user name or email"
      />
    </nz-input-group>
  </div>
</div>
<ng-template #suffixButton>
  <button
    nz-button
    nzType="primary"
    nzSize="small"
    nzSearch
    (click)="fetchPacksSubscription()"
  >
    Search
  </button>
</ng-template>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Packs</span>
    </div>
    <div nz-col class="flex gap-2 items-center">
      <nz-switch
        (ngModelChange)="testEventChangeFn($event)"
        [(ngModel)]="showTest"
        nzCheckedChildren="Hide Test Packs Subscription"
        nzUnCheckedChildren="Show Test Packs Subscription"
        class="mr-3"
      ></nz-switch>
      <button
        class="btn-color"
        (click)="exportDataFn()"
        nz-button
        nzSize="small"
        nzType="primary"
      >
        <span nz-icon nzType="download"></span>
        Export
      </button>
      <button
        class="btn-color"
        nz-button
        nzSize="small"
        nzType="primary"
        (click)="resetFilter()"
      >
        Clear filter
      </button>
    </div>
  </div>
</ng-template>
<nz-spin
  [nzSpinning]="tableLoading"
  nzTip="Fetching Anyo packs subscription...."
>
  <nz-table
    #basicTable
    [nzData]="tableData"
    [nzTitle]="tableHead"
    [nzScroll]="{ y: '500px' }"
    class="mt-5"
    [nzShowPagination]="true"
    nzFrontPagination="false"
    [nzTotal]="totalRecords"
    [nzPageSize]="pageSize"
    [nzBordered]="true"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="pageSizeOptions"
    [nzPageIndex]="page"
    nzTableLayout="fixed"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>User Name</th>
        <th>User email</th>
        <th>
          Partner Id
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerId">
            <span nz-icon nzTheme="outline" nzType="filter-o"></span>
          </nz-filter-trigger>
        </th>
        <th>Phone No</th>
        <th>Activated On</th>
        <th>Active Packs</th>
        <th>Completed Packs</th>
        <th>Total Packs Value</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>
          <button
            type="button"
            class="bg-transparent border-none p-0 m-0 underline cursor-pointer"
            (click)="goToFilterUsers(data.userDetails.userId)"
          >
            <nz-tag class="flex-wrap" [nzColor]="'green'">
              {{ data.userDetails.name }}
            </nz-tag>
          </button>
        </td>
        <td>{{ data.userDetails.email }}</td>
        <td>{{ data.userDetails.partnerId }}</td>
        <td>{{ data.userDetails.phoneNumber }}</td>
        <td>
          {{ utils.convertEpochToFormattedDate(data.activedOn.toString()) }}
        </td>
        <td>{{ data.activePacks }}</td>
        <td>{{ data.completedPacks }}</td>
        <td>{{ "₹ " + data.totalPackValue }}</td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>
<nz-dropdown-menu #partnerId="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Payment Type</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="partnerIdFilterChangeFn($event)">
          <div *ngFor="let topic of partnerIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="topic.value"
                [ngModel]="topic.checked"
                >{{ topic.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="fetchPacksSubscription()"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button
          class="m-1 btn-color"
          nz-button
          nzType="primary"
          (click)="resetFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
